import AnswerButtonGroup from "@/components/train/AnswerButtonGroup.vue";
import LogicalReasoning2DQuestion from "@/components/subject/LogicalReasoning2d/LogicalReasoning2DQuestion.vue";
export default {
  name: "LogicalReasoning2DRender",
  components: {
    LogicalReasoning2DQuestion,
    AnswerButtonGroup
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      answer: null
    };
  },
  methods: {
    onChoosed(l) {
      this.$emit('answer', l && l.length > 0 ? l[0] : null);
    },
    init() {
      this.answer = null;
    }
  },
  mounted() {
    this.init();
  }
};